/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import parse from 'html-react-parser'
import { Typography } from '@material-ui/core'

// Base styles - theme-based, used for all layouts except 'full'
const baseStyles = theme => ({
    headerWrapper: {
        marginTop: -16
    },
    title: {
        margin: 0,
        paddingTop: theme.title.paddingTop - 8 + 'px!important',
        paddingBottom: theme.title.paddingBottom - 8 + 'px!important',
        textTransform: theme.title.textTransform,
        [theme.breakpoints.up(600)]: {
            paddingTop: theme.title.paddingTop + 'px!important',
            paddingBottom: theme.title.paddingBottom + 'px!important'
        },
        color: theme.header?.color && theme.header.color + '!important',
        textShadow: 'none!important',
        marginTop: theme.layoutAlias === 'exclusive' ? '0!important' : 'inherit',
        lineHeight: 1.15
    },
    emptyTitle: {
        paddingTop: '0!important',
        paddingBottom: '20px!important'
    },
    description: {
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.description.marginBottom,
        [theme.breakpoints.up(600)]: {
            paddingBottom: theme.spacing(1),
            marginBottom: theme.description.marginBottom,
            marginTop: -theme.spacing(1)
        },
        fontSize: '0.98rem',
        textAlign: theme.description.textAlign
    },
    emptyDescription: {
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.description.emptyMarginBottom
    },
    premiumExclusiveQuestionPageHeader: {
        background: theme.palette.primary.main,
        color: '#fff!important',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        marginLeft: -theme.spacing(2),
        marginRight: -theme.spacing(2),
        paddingTop: theme.spacing(0.75) + 'px!important',
        paddingBottom: theme.spacing(0.5) + 'px!important',
        marginTop: theme.paper ? -theme.paper.paddingTop : -theme.spacing(3) + 'px!important',
        marginBottom: theme.spacing(2),
        [theme.breakpoints.up(600)]: {
            border: '3px solid white',
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            paddingTop: theme.spacing(1.5) + 'px!important',
            paddingBottom: theme.spacing(0.75) + 'px!important',
            marginLeft: -theme.spacing(4),
            marginRight: -theme.spacing(4),
            marginTop: -theme.spacing(4) + 'px!important',
            marginBottom: theme.spacing(3)
        }
    },
    premiumExclusiveTitle: {
        color: '#fff!important',
        paddingTop: '0!important',
        marginTop: '12px!important',
        paddingBottom: '2px!important',
        textTransform: 'uppercase!important',
        fontSize: '22px!important',
        lineHeight: 1.25,
        fontWeight: '700!important'
    },
    premiumExclusiveDescription: {
        color: '#fff!important',
        paddingBottom: '0!important',
        marginBottom: '0!important'
    },
    hideOnMobile: {
        [theme.breakpoints.down(1280)]: {
            display: 'none'
        }
    },
    hideOnDesktop: {
        [theme.breakpoints.up(1280)]: {
            display: 'none'
        }
    },
    forceVisible: {
        display: 'block!important'
    }
})

// Enhanced styles - for layout='full' (FullPageQuestionApplication)
const enhancedStyles = theme => ({
    headerWrapper: {
        marginTop: -12,
        fontFamily: "'Plus Jakarta Sans', sans-serif"
    },
    title: {
        margin: 0,
        paddingTop: theme.title.paddingTop - 8 + 'px!important',
        paddingBottom: theme.title.paddingBottom - 8 + 'px!important',
        textTransform: 'none',
        [theme.breakpoints.up(600)]: {
            paddingTop: theme.title.paddingTop + 'px!important',
            paddingBottom: theme.title.paddingBottom + 'px!important'
        },
        color: '#1a2e23!important',
        textShadow: 'none!important',
        marginTop: theme.layoutAlias === 'exclusive' ? '0!important' : 'inherit',
        lineHeight: 1.2,
        fontFamily: "'Plus Jakarta Sans', sans-serif!important",
        fontWeight: '700!important'
    },
    emptyTitle: {
        paddingTop: '0!important',
        paddingBottom: '20px!important'
    },
    description: {
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.description.marginBottom,
        [theme.breakpoints.up(600)]: {
            paddingBottom: theme.spacing(1),
            marginBottom: theme.description.marginBottom,
            marginTop: -theme.spacing(1)
        },
        fontSize: '0.98rem',
        textAlign: theme.description.textAlign,
        fontFamily: "'Plus Jakarta Sans', sans-serif!important",
        color: '#4a5d52!important',
        lineHeight: '1.6!important'
    },
    emptyDescription: {
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.description.emptyMarginBottom
    },
    premiumExclusiveQuestionPageHeader: {
        background: theme.palette.primary.main,
        color: '#fff!important',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        marginLeft: -theme.spacing(2),
        marginRight: -theme.spacing(2),
        paddingTop: theme.spacing(0.75) + 'px!important',
        paddingBottom: theme.spacing(0.5) + 'px!important',
        marginTop: theme.paper ? -theme.paper.paddingTop : -theme.spacing(3) + 'px!important',
        marginBottom: theme.spacing(2),
        [theme.breakpoints.up(600)]: {
            border: '3px solid white',
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            paddingTop: theme.spacing(1.5) + 'px!important',
            paddingBottom: theme.spacing(0.75) + 'px!important',
            marginLeft: -theme.spacing(4),
            marginRight: -theme.spacing(4),
            marginTop: -theme.spacing(4) + 'px!important',
            marginBottom: theme.spacing(3)
        }
    },
    premiumExclusiveTitle: {
        color: '#fff!important',
        paddingTop: '0!important',
        marginTop: '12px!important',
        paddingBottom: '2px!important',
        textTransform: 'uppercase!important',
        fontSize: '22px!important',
        lineHeight: 1.25,
        fontWeight: '700!important'
    },
    premiumExclusiveDescription: {
        color: '#fff!important',
        paddingBottom: '0!important',
        marginBottom: '0!important'
    },
    hideOnMobile: {
        [theme.breakpoints.down(1280)]: {
            display: 'none'
        }
    },
    hideOnDesktop: {
        [theme.breakpoints.up(1280)]: {
            display: 'none'
        }
    },
    forceVisible: {
        display: 'block!important'
    }
})

class QuestionPageHeader extends PureComponent {
    state = {
        showFullDescription: false
    }

    handleShowFullDescription = () => {
        this.setState({ showFullDescription: true })
    }

    render() {
        const { showFullDescription } = this.state
        const { questionPage, theme, layout, classes } = this.props

        const isSignupPage = questionPage.isSignupPage
        const isExclusiveTheme = theme?.layout === 'exclusive'

        let title = questionPage.title
        let description = questionPage.description

        if (isSignupPage && isExclusiveTheme) {
            title = ''
            description = ''
        }

        if (isSignupPage && !isExclusiveTheme && theme?.themeHeader) {
            title = theme.themeHeader
            description = theme.themeDescription
        }

        return (
            <div
                className={
                    classes.headerWrapper +
                    ' questionPageHeader ' +
                    ' ' +
                    (layout === 'premium-exclusive' ? classes.premiumExclusiveQuestionPageHeader : '')
                }
            >
                <Typography
                    component="h4"
                    variant={questionPage.titleSize}
                    align="center"
                    className={
                        classes.title +
                        ' ' +
                        (!questionPage.title ? classes.emptyTitle : '') +
                        ' ' +
                        (layout === 'premium-exclusive' ? classes.premiumExclusiveTitle : '')
                    }
                    id={'question-page-title'}
                >
                    {title && parse(title)}
                </Typography>
                {description && !isSignupPage && (
                    <Typography
                        component="div"
                        variant="body1"
                        align="center"
                        color="textSecondary"
                        className={classes.description + ' ' + (layout === 'premium-exclusive' ? classes.premiumExclusiveDescription : '')}
                        id={'question-page-description'}
                    >
                        {parse(description)}
                    </Typography>
                )}
                {Boolean(isSignupPage) && !isExclusiveTheme && theme?.themeDescription && (
                    <>
                        {!showFullDescription && theme.themeDescriptionMobile && (
                            <div className={classes.hideOnDesktop}>
                                <Typography
                                    component="div"
                                    variant="body1"
                                    align="center"
                                    color="textSecondary"
                                    className={
                                        classes.description + ' ' + (layout === 'premium-exclusive' ? classes.premiumExclusiveDescription : '')
                                    }
                                    style={{cursor: 'pointer'}}
                                    onClick={this.handleShowFullDescription}
                                    id={'question-page-description'}
                                >
                                    {parse(theme.themeDescriptionMobile)}
                                </Typography>
                            </div>
                        )}
                        <div
                            className={
                                classes.hideOnMobile + ' ' + (showFullDescription || !theme.themeDescriptionMobile ? classes.forceVisible : '')
                            }
                        >
                            <Typography
                                component="div"
                                variant="body1"
                                align="center"
                                color="textSecondary"
                                className={classes.description + ' ' + (layout === 'premium-exclusive' ? classes.premiumExclusiveDescription : '')}
                                id={'question-page-description'}
                            >
                                {parse(theme.themeDescription)}
                            </Typography>
                        </div>
                    </>
                )}
                {!description && (
                    <Typography component="div" variant="body1" align="center" color="textSecondary" className={classes.emptyDescription} />
                )}
            </div>
        )
    }
}

// Create base-styled component
const QuestionPageHeaderWithBaseStyles = withStyles(baseStyles)(QuestionPageHeader)

// Higher-order component to inject enhanced styles when layout='full'
// Pre-create styled components at module level to prevent re-renders
const QuestionPageHeaderEnhanced = withStyles(enhancedStyles)(QuestionPageHeader)

// Style switcher - returns pre-created components to prevent re-mounting
class QuestionPageHeaderStyleSwitcher extends PureComponent {
    render() {
        const { layout, ...props } = this.props

        if (layout === 'full') {
            return <QuestionPageHeaderEnhanced {...props} layout={layout} />
        }

        // Use base styles
        return <QuestionPageHeaderWithBaseStyles {...props} layout={layout} />
    }
}

export default QuestionPageHeaderStyleSwitcher
